export default "__VITE_ASSET__C5Yi3SAJ__"